import { memo, useEffect, useState } from 'react';

import { Grid, Skeleton } from '@mui/material';

import ThreeDays from './ThreeDays';

import BestFastConvenient from './BestFastConvenient/BestFastConvenient';
import BestPriceByAirlines from './BestPriceByAirlines/BestPriceByAirlines';

import { sxStyle } from './styles';

const TabPanel = props => {
  const { children, value, index, ...other } = props;

  return (
    <Grid
      container
      sx={{
        width: 'auto',
        display: 'flex',
        flexDirection: 'column',
        mb: { xs: '20px', lg: '30px' },
        mt: { xs: '20px', lg: '30px' },
        mx: { xs: '20px', lg: 0 },
      }}
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </Grid>
  );
};

const TabButtonsFlights = memo(
  ({
    bestPriceByAirline,
    bestFastConvenient,
    scrollToCluster,
    isCustomSearch,
    tabButton,
    flightsInUSD,
    changeSearch,
    originalSearchType,
  }) => {
    const [selectedId, setSelectedId] = useState(null);

    useEffect(() => {
      if (!isCustomSearch) return;
      if (!bestPriceByAirline?.length) return;

      const elem = bestPriceByAirline[0]?.combinations?.[0];

      if (elem?.cluster_id) {
        setSelectedId(elem.cluster_id);
      }
    }, [isCustomSearch, bestPriceByAirline]);

    useEffect(() => {
      if (isCustomSearch) return;
      if (!bestFastConvenient?.convenient?.cluster_id) return;

      setSelectedId(bestFastConvenient.convenient.cluster_id);
    }, [isCustomSearch, bestFastConvenient]);

    const handleScroll = elem => {
      if (!elem?.cluster_id) {
        console.error('Scroll cancelado: cluster_id inexistente', elem);
        return;
      }

      setSelectedId(elem.cluster_id);
      scrollToCluster(elem);
    };

    const fetchFlexibleSearch = () => {
      if (window.vthws?.go) window.vthws.go();
    };

    useEffect(() => {
      if (!changeSearch && tabButton == 2) {
        fetchFlexibleSearch();
      }
    }, [changeSearch, tabButton]);

    return (
      <TabPanel>
        <>
          {tabButton == 2 && (
            <ThreeDays
              tripType={{ search_type: originalSearchType }}
              isInUSD={flightsInUSD.isInUSD}
            />
          )}

          {bestPriceByAirline.length > 0 ? (
            <BestPriceByAirlines
              data={bestPriceByAirline}
              handleScroll={handleScroll}
              selectedId={selectedId}
              isCustomSearch={isCustomSearch}
            />
          ) : (
            <Grid container sx={sxStyle.bestPriceAirContainerCustom}>
              <Grid
                container
                spacing={0}
                sx={sxStyle.bestPriceAirCardsContainer}
              >
                <Grid item xs={3} md={3} style={{ padding: '20px 10px' }}>
                  <Skeleton variant="text" height={89} />
                </Grid>
                <Grid item xs={3} md={3} style={{ padding: '20px 10px' }}>
                  <Skeleton variant="text" height={89} />
                </Grid>
                <Grid item xs={3} md={3} style={{ padding: '20px 10px' }}>
                  <Skeleton variant="text" height={89} />
                </Grid>
                <Grid item xs={3} md={3} style={{ padding: '20px 10px' }}>
                  <Skeleton variant="text" height={89} />
                </Grid>
              </Grid>
            </Grid>
          )}
          {!isCustomSearch && (
            <BestFastConvenient
              data={bestFastConvenient}
              handleScroll={handleScroll}
              selectedId={selectedId}
            />
          )}
        </>
      </TabPanel>
    );
  }
);

export default TabButtonsFlights;
